var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "modal-submit-drafts",
      attrs: {
        name: _vm.nameModal,
        width: "30%",
        height: "auto",
        scrollable: true
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c(
        "div",
        { staticClass: "modal-header border-0 justify-content-end pb-0" },
        [
          _c(
            "div",
            {
              staticClass: "modal-close-img",
              on: {
                click: function($event) {
                  _vm.onCancel()
                },
                mouseover: function($event) {
                  _vm.isHoverClose = true
                },
                mouseleave: function($event) {
                  _vm.isHoverClose = false
                }
              }
            },
            [
              !_vm.isHoverClose
                ? _c("img", {
                    attrs: {
                      src: require("../../../static/img/info-modal-close.svg"),
                      alt: "close"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isHoverClose
                ? _c("img", {
                    attrs: {
                      src: require("../../../static/img/info-modal-close-hover.svg"),
                      alt: "close"
                    }
                  })
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "main-content" }, [
        _c("p", { staticClass: "text-question" }, [
          _vm._v(_vm._s(_vm.textQuestion))
        ]),
        _vm._v(" "),
        _vm.listTextDescription.length == 0
          ? _c("p", { staticClass: "text-description" }, [
              _c("b", [_vm._v(_vm._s(_vm.textDescription))])
            ])
          : _c("p", { staticClass: "text-description" }, [
              _c(
                "ul",
                _vm._l(_vm.listTextDescription, function(item, index) {
                  return _c("li", { key: index }, [
                    _c("b", [_vm._v(_vm._s(item))])
                  ])
                })
              )
            ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-container" },
          [
            _c(
              "b-button",
              { staticClass: "btn-cancel", on: { click: _vm.onCancel } },
              [_vm._v("\n        Cancel\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "btn-submit",
                attrs: { disabled: _vm.loadingCovidSelect },
                on: { click: _vm.onSubmit }
              },
              [
                _vm.loadingCovidSelect ? _c("b-spinner") : _vm._e(),
                _vm._v("\n        Yes\n      ")
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cca9f9da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cca9f9da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ModalChangeToggleVaccines.vue
// module id = 1658
// module chunks = 1